<script setup>
  import ModalTextInput from '@/components/controls/ModalTextInput.vue';

  const inputValue = defineModel();

  const props = defineProps({
    modalTitle: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      default: null
    },
    acceptButtonText: {
      type: String,
      default: 'Save'
    },
    required: {
      type: Boolean,
      default: false
    }
  });

  const emit = defineEmits(['cancel', 'accept']);

  function onCancel() {
    emit('cancel');
  }

  function onAccept() {
    emit('accept');
  }
</script>

<template>
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">{{ props.modalTitle }}?</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <ModalTextInput
          v-model="inputValue"
          id="container-name"
          name="container-name"
          :labelText="props.labelText"
          :required="props.required"
        />
      </div>
    </div>         
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="onCancel"
          class="jwx-button"
        >
          Cancel
      </button>
        <button 
          type="button" 
          @click.prevent="onAccept"
          class="jwx-button jwx-button--success"
        >
          {{ props.acceptButtonText }}
        </button>
      </div>
    </div>
</template>